<template>
  <div class="page">
    <div
      class="groups-query-list card"
      :class="{ '-loading': loading }"
    >
      <loader v-if="loading"></loader>

      <div class="header">
        <div class="description">
          <h2 class="title">Edição template</h2>
          <p class="subtitle">Nessa tela você pode alterar o template</p>
        </div>

        <card-actions v-if="template.consultations.length === 0">
          <router-link
            :to="{ name: 'Template-Vehicle-Add' }"
            class="btn btn-primary -sm"
          >Adicionar Consulta ao Template<ion-icon name="add"></ion-icon></router-link>
        </card-actions>
      </div>

      <div
        class="body"
        :class="{ '-no-padding' : !errors.cantLoadList && !errors.cantLoadGroupQueriesList }"
      >
        <div class="alert -danger" v-if="errors.cantLoadList">
          <p class="title">Ops!</p>

          <p>
            Infelizmente aconteceu um erro ao tentar carregar suas consultas,
            por favor tente novamente ou contate nossa equipe.
          </p>
        </div>
        <div class="alert -danger" v-if="errors.cantLoadGroupQueriesList">
          <template slot="title">Ops!</template>

          <p>
            Infelizmente aconteceu um erro ao tentar exibir os detalhes,
            por favor tente novamente ou contate nossa equipe.
          </p>
        </div>

        <div class="pl-6 pr-6 pb-6">
          <form action="" @submit.prevent>
            <div class="input-group">
              <label for="name" class="label w-full">Nome do template</label>
              <input
                class="form-control"
                id="name"
                type="text"
                placeholder="Nome do template"
                v-model="template.name"
                autocomplete
                required
              >
              <button type="button" class="btn btn-success" @click="renameTemplate">
                <ion-icon name="save"></ion-icon> Renomear
              </button>
            </div>
          </form>
        </div>

        <div class="bg-primary-100 border border-primary-400 text-primary-700 px-4 py-3 rounded relative bg-opacity-25 mb-5 ml-6 mr-6" role="alert" v-if="template.consultations.length > 0">
          <span class="block sm:inline">Só é possivel adicionar apenas uma consulta para templates de veículos.</span>
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3"></span>
        </div>

        <template v-if="!errors.cantLoadList">
          <table class="list">
            <thead>
            <tr class="-head">
              <th>Consulta</th>
              <th>Modelo</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <template v-for="consultation in template.consultations">
              <tr class="row">
                <td class="cell -queryinfo">{{ consultation.label }}</td>
                <td class="cell -queryinfo">{{ humanizeFields(consultation.fields || []) }}</td>
                <td class="cell -expanseaction">
                  <button class="btn -sm btn-danger" title="Excluir" @click="removeConsultation(consultation.id)">
                    <ion-icon name="trash" role="img" class="xs hydrated"></ion-icon>
                  </button>
                </td>
              </tr>
            </template>
            <template v-if="template.consultations.length === 0">
              <tr class="row">
                <td class="cell text-center" colspan="3">Nenhuma consulta adicionada.</td>
              </tr>
            </template>
            </tbody>
          </table>
        </template>

        <router-link :to="{ name: 'Template-Vehicle'}" class="btn btn-primary ml-6 mb-6">Voltar</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import currency from '@/support/filters/currency';
import dateFormat from '@/support/filters/dateFormat';
import queriesCompletedText from '@/compliance/filters/queriesCompletedText';
import apiLink from '@/support/filters/apiLink';
import CardActions from '@/support/components/card/CardActions.vue';
import Loader from '@/support/components/Loader.vue';

export default {
  name: 'Index',

  data() {
    return {
      loading: false,
      page: 1,
      groupExpanded: '',
      canSelectAllQueriesToDownload: false,
      errors: {
        cantLoadList: false,
        cantLoadGroupQueriesList: false,
      },
    };
  },

  methods: {
    /**
     * Fetch the groups list.
     *
     * @returns {Promise<void>}
     */
    async fetchTemplate() {
      try {
        this.resetErrors();
        this.loading = true;

        await this.$store.dispatch('template/fetchTemplate', this.$route.params.id);
        this.template.consultations.sort((a, b) => {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }

          return 0;
        });
      } catch {
        this.errors.cantLoadList = true;
      } finally {
        this.loading = false;
      }
    },

    async editTemplate(id) {
      await this.$router.push({
        name: 'Template-Vehicle-Add',
        params: { id },
      });
    },

    async removeConsultation(id) {
      this.loading = true;
      await this.$store.dispatch('template/removeConsultationInTemplate', {
        templateId: this.$route.params.id,
        consultationId: id,
      });
      this.$notify({
        group: 'app',
        type: 'success',
        title: 'Sucesso!',
        text: 'Consulta removida com sucesso.',
      });
      await this.fetchTemplate();
      this.loading = false;
    },

    async renameTemplate() {
      this.loading = true;
      await this.$store.dispatch('template/renameTemplate', {
        id: this.$route.params.id,
        name: this.template.name,
      });
      this.$notify({
        group: 'app',
        type: 'success',
        title: 'Sucesso!',
        text: 'Template renomeado com sucesso.',
      });
      await this.fetchTemplate();
      this.loading = false;
    },

    /**
     * Reset the all errors to initial value.
     */
    resetErrors() {
      this.errors.cantLoadList = false;
      this.errors.cantLoadGroupQueriesList = false;
    },

    estimatedValue(length) {
      return length * this.user.plan.price_per_consultation;
    },

    humanizeFields(fields) {
      return fields.map((field) => field.label).join(', ');
    },
  },

  computed: {
    ...mapState('template', {
      template: 'template',
    }),
    ...mapState('auth', {
      accessToken: 'accessToken',
      user: 'user',
    }),
  },

  async mounted() {
    await this.fetchTemplate();
  },

  watch: {
  },

  filters: {
    currency,
    dateFormat,
    queriesCompletedText,
    apiLink,
  },

  components: {
    CardActions,
    Loader,
  },
};
</script>

<style lang="scss" scoped>
.groups-query-list {
  > .body {
    > table.list {
      > thead,
      > tbody {
        > tr {
          > th,
          > td {
            padding-top: 0.8rem;
            padding-bottom: 0.8rem;

            .form-group {
              @apply mb-0;
            }

            &.-expanseaction {
              @apply text-center;
              @apply w-full;
              display: flex;
              justify-content: flex-end;
              gap: 8px;

              .btn {
                //padding: 0.2rem 0.5rem;

                > ion-icon {
                  left: 0;
                }
              }
            }

            &.-selectaction {
              .form-group {
                @apply mb-0;
              }
            }

            &.-queryinfo {
              @apply text-sm;
              @apply text-secondary-900;
            }

            &.-statusinfo {
              white-space: nowrap;
              @apply pr-1;
            }
          }

          &.-head {
            @apply text-left;

            > .cell {
              @apply text-secondary-800;
              @apply text-xs;
              @apply font-bold;
            }
          }

          &.-detail,
          &.-expanded {
            @apply border-b-0;
            @apply border-t-0;
            @apply bg-primary-100;
            @apply bg-opacity-50;
          }

          &.-detail {
            &:last-child {
              @apply border-b;
            }
          }
        }
      }
    }

    > .navList {
      @apply flex;
      @apply justify-center;
    }
  }
}
</style>
